import {Page, Pages, PracticeData} from "@/libwyze-shared/types";
import {StringUtil} from "@/shared/string_util";
import {getMemberAuth} from "@/shared/auth";
import {MESSAGING_TEMPLATE_KTM, MessagingSendChannel, MessagingTemplateId} from "@/libwyze-common/api/types";
import {BaseSmsCampaignFragment, Sms} from "./BaseSmsCampaignFragment";
import React, {ReactElement} from "react";
import {MessageCampaignConfig, MessageCampaignConfigType} from "../BaseMessageCampaignFragment";
import {FestivalSmsCampaignCustomizeOptions, FestivalSmsCampaignTemplate} from "@/vantage-shared/types";
import {$KTS} from "@/shared/keytext";
import {Typography} from "@mui/material";

export class FestivalSmsCampaignFragment extends BaseSmsCampaignFragment<FestivalSmsCampaignCustomizeOptions> {

  private readonly memberAuth = getMemberAuth();

  protected createCampaignConfig(): MessageCampaignConfig {
    return {
      name: "Festival",
      type: MessageCampaignConfigType.MESSAGING,
      messaging: {
        channel: MessagingSendChannel.SMS,
        title: "Send festival SMS",
        text: "Send personalized festival SMSes to your patients. With more than a dozen festivals supported, it's easy to stay in touch with your patients. Simply configure the kind of message you would like to send from our collection of templates, and we'll automatically send it out at the right time.",
        templateVariables: [
          Pages.getInstance().getListItem(PracticeData.provider().practiceId).practicePageProfile.basicInfo.name,
          this.memberAuth.member.user.firstname,
        ],
        templateId: MessagingTemplateId.PATIENT_FESTIVAL_GREETING,
      }
    };
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    this.setState({
      customizeOptions: await FestivalSmsCampaignCustomizeOptions.load(PracticeData.shared().practiceId),
    });
  }

  private replaceSmsTemplatePlaceholders(smsText: string, template: FestivalSmsCampaignTemplate, practiceName: string): Sms {
    return {
      body: StringUtil.replacePlaceholders(smsText, ...this.campaignConfig.messaging.templateVariables.map((str, index) => $KTS(`${index + 1}`, str))),
    }
  }

  private smsText: string;

  protected async generateMessage(practicePage: Page): Promise<Sms> {
    if (!this.smsText) {
      console.log(this.campaignConfig.messaging.templateId);
      this.smsText = MESSAGING_TEMPLATE_KTM.findMetadata(this.campaignConfig.messaging.templateId).templateText;
    }
    return this.replaceSmsTemplatePlaceholders(this.smsText, this.state.customizeOptions.template, practicePage.practicePageProfile.basicInfo.name);
  }

  protected renderPreview(sms: Sms): ReactElement {
    return <Typography>{sms.body}</Typography>
  }
}